import { RadioGroup_Field_default } from "./chunk-XA6ZDJCU.js";
import { RadioGroup_default } from "./chunk-C37QIPWZ.js";
import { CheckableGroup_MoreButton_default } from "./chunk-4KDZJZIW.js";

// src/components/RadioGroup/index.ts
var RadioGroupComponent = RadioGroup_default;
RadioGroupComponent.Field = RadioGroup_Field_default;
RadioGroupComponent.Field.displayName = "RadioGroup.Field";
RadioGroupComponent.MoreButton = CheckableGroup_MoreButton_default;
RadioGroupComponent.MoreButton.displayName = "RadioGroup.MoreButton";
export { RadioGroupComponent };